"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var downshift_1 = require("downshift");
var Portal_1 = __importDefault(require("../portal/Portal"));
var ChipSelect_styled_1 = require("./ChipSelect.styled");
var components_1 = require("../../styles/components");
var utils_1 = require("../../utils");
var helpers_1 = require("./helpers");
var Input_1 = __importDefault(require("../input/Input"));
function ChipSelect(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, placeholder = _a.placeholder, label = _a.label, name = _a.name, onChange = _a.onChange, options = _a.options, value = _a.value, className = _a.className, dropdownStyle = _a.dropdownStyle, required = _a.required, searchable = _a.searchable, _c = _a.config, _d = _c === void 0 ? {} : _c, _e = _d.filterDetector, filterDetector = _e === void 0 ? function (dataItem, filterValue) {
        return dataItem.label.toLowerCase().includes(filterValue.toLowerCase());
    } : _e, _f = _d.dropdownItemLabelBuilder, dropdownItemLabelBuilder = _f === void 0 ? function (item) { return item.label; } : _f, _g = _d.selectedLabelBuilder, selectedLabelBuilder = _g === void 0 ? function (item) { return item.label; } : _g, _h = _d.labels, labels = _h === void 0 ? {
        searchPlaceholder: 'Search',
    } : _h;
    var _j = react_1.useState(value), selectedItems = _j[0], setSelectedItems = _j[1];
    var _k = react_1.useState(''), searchString = _k[0], setSearchString = _k[1];
    var searchChangeHandler = react_1.useCallback(function (e) { return setSearchString(e.target.value); }, []);
    var handleIsOpenChange = react_1.useCallback(function (_a) {
        var isOpen = _a.isOpen;
        if (isOpen) {
            setSearchString('');
        }
    }, []);
    var handleSelectedItemChange = react_1.useCallback(function (_a) {
        var selectedItem = _a.selectedItem;
        if (!selectedItem) {
            return;
        }
        var index = selectedItems.findIndex(function (item) { return item.value === selectedItem.value; });
        var nextSelectedItems = index > 0
            ? __spreadArrays(selectedItems.slice(0, index), selectedItems.slice(index + 1)) : index === 0
            ? __spreadArrays(selectedItems.slice(1)) : __spreadArrays(selectedItems, [selectedItem]);
        setSelectedItems(nextSelectedItems);
        onChange(nextSelectedItems);
    }, [onChange, selectedItems]);
    var displayedOptions = react_1.useMemo(function () {
        var selectedItemsSet = selectedItems.reduce(function (acc, item) { return acc.add(item.value); }, new Set());
        return options.filter(function (opt) {
            return !selectedItemsSet.has(opt.value) &&
                (searchable && filterDetector
                    ? filterDetector(opt, searchString)
                    : true);
        });
    }, [filterDetector, options, searchString, searchable, selectedItems]);
    var _l = downshift_1.useSelect({
        stateReducer: helpers_1.stateReducer,
        items: displayedOptions,
        selectedItem: null,
        onSelectedItemChange: handleSelectedItemChange,
        onIsOpenChange: handleIsOpenChange,
    }), isOpen = _l.isOpen, getToggleButtonProps = _l.getToggleButtonProps, getLabelProps = _l.getLabelProps, getMenuProps = _l.getMenuProps, getItemProps = _l.getItemProps, highlightedIndex = _l.highlightedIndex, selectItem = _l.selectItem, closeMenu = _l.closeMenu;
    var selectedItemChips = react_1.useMemo(function () {
        return selectedItems.map(function (item) {
            var removeHandler = function (e) {
                e.stopPropagation();
                selectItem(item);
            };
            var itemLabel = selectedLabelBuilder(item);
            return (react_1.default.createElement(ChipSelect_styled_1.ChipItem, { key: item.key, onRemove: removeHandler, disabled: disabled }, typeof itemLabel === 'string' ? (react_1.default.createElement("div", { title: itemLabel }, itemLabel)) : (itemLabel)));
        });
    }, [disabled, selectItem, selectedItems, selectedLabelBuilder]);
    var _m = utils_1.useScrollAnchor(isOpen), anchorRef = _m[0], listRef = _m[1];
    react_1.useEffect(function () {
        utils_1.setListMenuDomRect(isOpen, listRef, anchorRef);
        if (selectedItems.length === options.length) {
            closeMenu();
        }
    }, [anchorRef, closeMenu, isOpen, listRef, options.length, selectedItems]);
    react_1.useEffect(function () {
        utils_1.setListMenuDomRect(isOpen, listRef, anchorRef);
    }, [anchorRef, isOpen, listRef]);
    react_1.useEffect(function () {
        setSelectedItems(value);
    }, [value]);
    var toggleButtonProps = getToggleButtonProps({
        disabled: disabled,
        id: name,
        ref: anchorRef,
    });
    var displayedOptionsComponents = react_1.useMemo(function () {
        return displayedOptions.map(function (item, index) {
            var isChecked = selectedItems.some(function (selectedItem) { return selectedItem.value === item.value; });
            var isActive = highlightedIndex === index;
            var itemLabel = dropdownItemLabelBuilder(item, isActive, isChecked);
            return (react_1.default.createElement(components_1.StyledListItem, __assign({}, getItemProps({
                item: item,
                index: index,
            }), { key: index, isActive: isActive, isChecked: isChecked }), itemLabel));
        });
    }, [
        displayedOptions,
        dropdownItemLabelBuilder,
        getItemProps,
        highlightedIndex,
        selectedItems,
    ]);
    return (react_1.default.createElement(ChipSelect_styled_1.StyledSelectWrapper, { className: className },
        label ? (react_1.default.createElement(components_1.InputLabel, __assign({}, getLabelProps({ htmlFor: name, required: required })), label)) : null,
        react_1.default.createElement(ChipSelect_styled_1.SelectInputButton, __assign({}, toggleButtonProps, { as: "button" }), selectedItemChips && selectedItemChips.length ? (selectedItemChips) : (react_1.default.createElement(ChipSelect_styled_1.SelectText, null,
            react_1.default.createElement(components_1.PlaceholderText, null, placeholder)))),
        react_1.default.createElement(Portal_1.default, null, searchable ? (react_1.default.createElement(components_1.StyledListWithSearch, __assign({ style: dropdownStyle }, getMenuProps({ ref: listRef })), isOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Input_1.default, { className: "search-box", name: name + "-search", value: searchString, onChange: searchChangeHandler, placeholder: labels.searchPlaceholder }),
            react_1.default.createElement("ul", { className: "item-list" }, displayedOptionsComponents))))) : (react_1.default.createElement(components_1.StyledList, __assign({ style: dropdownStyle }, getMenuProps({ ref: listRef })), isOpen && displayedOptionsComponents)))));
}
ChipSelect.defaultProps = {
    value: [],
};
exports.default = ChipSelect;
//# sourceMappingURL=ChipSelect.js.map